import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    CheckCircle2,
    ArrowRight,
    Users,
    Truck,
    Link2,
    ToggleLeft,
    FileText,
    ShieldCheck
} from 'lucide-react';
import './Solutions.css';
import '../LandingPage.css';

import tmsLogo from '../../../assets/TmsLogoh.png';

const GestionRessources = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="saas-container">
            {/* Navbar */}
            <nav className="landing-nav saas-nav">
                <div className="nav-container">
                    <div className="nav-logo">
                        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
                            <img src={tmsLogo} alt="Bfret Logo" style={{ height: '32px' }} />
                        </Link>
                    </div>
                    <div className="nav-links">
                        <div className="nav-dropdown">
                            <span className="nav-dropdown-toggle">Solutions</span>
                            <div className="nav-dropdown-menu">
                                <Link to="/solutions/planification-intelligente">Planification intelligente</Link>
                                <Link to="/solutions/suivi-temps-reel">Suivi en temps réel</Link>
                                <Link to="/solutions/documents-centralises">Documents centralisés</Link>
                                <Link to="/solutions/rapports-analytics">Rapports & Analytics</Link>
                                <Link to="/solutions/gestion-ressources">Gestion des ressources</Link>
                                <Link to="/solutions/ai-agent-center">AI Agent Center</Link>
                            </div>
                        </div>
                        <Link to="/contact" className="btn-primary saas-btn-primary" style={{ marginLeft: '1rem' }}>Démo</Link>
                    </div>
                </div>
            </nav>

            {/* Hero */}
            <section style={{ padding: '6rem 5% 4rem', textAlign: 'center', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <span className="saas-feature-tag" style={{ display: 'inline-block', marginBottom: '1.5rem', backgroundColor: '#e0e7ff', color: '#4338ca', padding: '0.5rem 1rem', borderRadius: '9999px', fontWeight: '600' }}>Chauffeurs, Véhicules & Remorques</span>
                <h1 style={{ fontSize: '3.5rem', maxWidth: '950px', margin: '0 auto 1.5rem', color: '#0f172a', lineHeight: '1.1' }}>
                    Gérez toutes vos ressources depuis un seul endroit
                </h1>
                <p style={{ fontSize: '1.25rem', maxWidth: '750px', margin: '0 auto 2.5rem', color: '#475569', lineHeight: '1.6' }}>
                    Chauffeurs, véhicules, remorques... Centralisez la gestion complète de vos ressources opérationnelles, suivez leurs disponibilités et préparez chaque mission avec les bons acteurs.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '0.875rem 2.5rem', fontSize: '1.1rem', borderRadius: '8px' }}>
                        Demander une démo
                    </Link>
                </div>
            </section>

            {/* Quick Benefits */}
            <section style={{ padding: '4rem 5%', backgroundColor: '#ffffff' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Disponibilités en temps réel</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>Sachez exactement quels chauffeurs et véhicules sont disponibles avant d'assigner une nouvelle mission.</p>
                    </div>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Fiches complètes par ressource</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>Chaque chauffeur, camion et remorque dispose de sa propre fiche avec toutes les informations opérationnelles nécessaires.</p>
                    </div>
                    <div style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ fontSize: '1.25rem', color: '#0f172a', marginBottom: '1rem' }}>Historique des missions</h3>
                        <p style={{ color: '#475569', margin: 0, lineHeight: '1.5' }}>Consultez l'ensemble des missions passées associées à chaque chauffeur pour analyser l'activité individuelle.</p>
                    </div>
                </div>
            </section>

            {/* Section 1: Chauffeurs */}
            <section className="saas-feature-section" style={{ paddingTop: '5rem', paddingBottom: '4rem', borderTop: '1px solid #f1f5f9' }}>
                <div className="saas-feature-grid">
                    <div className="saas-feature-text" style={{ paddingRight: '2rem' }}>
                        <span className="saas-feature-tag">Chauffeurs</span>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1.5rem', color: '#0f172a' }}>
                            Gérez vos conducteurs de A à Z
                        </h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', marginBottom: '2.5rem', lineHeight: '1.6' }}>
                            Créez et maintenez les fiches de vos chauffeurs, contrôlez leur disponibilité en temps réel, activez ou désactivez leur accès à l'application mobile, et conservez leurs documents importants.
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Disponibilité ajustable manuellement
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Passez un chauffeur en "indisponible" (congés, maladie) d'un simple clic pour qu'il n'apparaisse plus dans les choix d'assignation.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Activation de l'accès mobile
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Activez ou désactivez l'accès d'un chauffeur à l'application mobile sans supprimer sa fiche.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Documents chauffeur
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Attachez et gérez les documents de chaque conducteur (permis, carte conducteur) directement sur sa fiche.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Historique des missions
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Consultez l'ensemble des missions passées et en cours d'un conducteur depuis sa fiche détaillée.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="saas-feature-visual" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {/* Driver list mockup */}
                        <div style={{ position: 'relative', width: '100%', maxWidth: '500px' }}>
                            <div style={{ position: 'absolute', inset: '-10px', background: 'linear-gradient(to right, #e0e7ff, #f3e8ff)', filter: 'blur(30px)', opacity: '0.5', borderRadius: '20px', zIndex: 0 }}></div>
                            <div style={{ position: 'relative', zIndex: 1, backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 20px 40px -10px rgba(0,0,0,0.12)' }}>
                                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontWeight: '700', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <Users size={18} /> Mes Chauffeurs
                                    </span>
                                    <span style={{ fontSize: '0.85rem', color: '#4338ca', fontWeight: '600' }}>+ Ajouter</span>
                                </div>
                                {[
                                    { name: 'Jean Dupont', license: 'B-12345', available: true, active: true },
                                    { name: 'Marc Leblanc', license: 'C-98765', available: false, active: true },
                                    { name: 'Sophie Martin', license: 'C-44567', available: true, active: true },
                                ].map((driver, i) => (
                                    <div key={i} style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #f8fafc', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <div style={{ width: '38px', height: '38px', borderRadius: '50%', backgroundColor: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontWeight: '700', color: '#4338ca', fontSize: '0.9rem' }}>
                                            {driver.name.split(' ').map(n => n[0]).join('')}
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <p style={{ margin: '0 0 0.2rem', fontSize: '0.9rem', fontWeight: '600', color: '#0f172a' }}>{driver.name}</p>
                                            <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>Permis : {driver.license}</p>
                                        </div>
                                        <span style={{ fontSize: '0.78rem', fontWeight: '600', padding: '0.2rem 0.6rem', borderRadius: '9999px', backgroundColor: driver.available ? '#ecfdf5' : '#fef2f2', color: driver.available ? '#059669' : '#dc2626' }}>
                                            {driver.available ? 'Disponible' : 'Indisponible'}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Véhicules */}
            <section className="saas-feature-section alt-bg" style={{ paddingTop: '5rem', paddingBottom: '5rem', backgroundColor: '#f8fafc' }}>
                <div className="saas-feature-grid reverse">
                    <div className="saas-feature-text" style={{ paddingLeft: '2rem' }}>
                        <span className="saas-feature-tag">Véhicules & Remorques</span>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '1.5rem', color: '#0f172a' }}>
                            Suivez l'état de votre flotte en temps réel
                        </h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', marginBottom: '2.5rem', lineHeight: '1.6' }}>
                            Enregistrez vos camions et remorques, mettez à jour leur statut au quotidien et vérifiez en un instant si une ressource est disponible pour une prochaine mission.
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Gestion du statut véhicule
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Chaque véhicule peut être marqué comme Disponible, Indisponible ou En maintenance pour refléter son état réel.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Gestion des remorques
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Gérez votre parc de remorques séparément : créez, mettez à jour et vérifiez la disponibilité de chacune avant de les affecter à une mission.
                                </p>
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#0f172a', marginBottom: '0.5rem' }}>
                                    <CheckCircle2 size={24} color="var(--saas-primary)" />
                                    Vérification de disponibilité
                                </h3>
                                <p style={{ fontSize: '1.05rem', color: '#475569', margin: 0, paddingLeft: '2.25rem' }}>
                                    Interrogez instantanément la disponibilité d'une remorque spécifique avant de planifier une nouvelle mission.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="saas-feature-visual" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {/* Vehicle status mockup */}
                        <div style={{ position: 'relative', width: '100%', maxWidth: '480px' }}>
                            <div style={{ position: 'absolute', inset: '-10px', background: 'linear-gradient(to left, #e0e7ff, #f3e8ff)', filter: 'blur(30px)', opacity: '0.5', borderRadius: '20px', zIndex: 0 }}></div>
                            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
                                    <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #f1f5f9', fontWeight: '700', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <Truck size={18} /> Flotte de véhicules
                                    </div>
                                    {[
                                        { plate: 'AB-123-CD', type: 'Porteur 19T', status: 'Disponible', color: '#059669', bg: '#ecfdf5' },
                                        { plate: 'EF-456-GH', type: 'Semi-remorque', status: 'En mission', color: '#b45309', bg: '#fef9c3' },
                                        { plate: 'IJ-789-KL', type: 'Porteur 7.5T', status: 'Maintenance', color: '#dc2626', bg: '#fef2f2' },
                                    ].map((v, i) => (
                                        <div key={i} style={{ padding: '0.9rem 1.5rem', borderBottom: '1px solid #f8fafc', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: '0 0 0.2rem', fontSize: '0.9rem', fontWeight: '700', color: '#0f172a' }}>{v.plate}</p>
                                                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>{v.type}</p>
                                            </div>
                                            <span style={{ fontSize: '0.78rem', fontWeight: '600', padding: '0.2rem 0.6rem', borderRadius: '9999px', backgroundColor: v.bg, color: v.color }}>{v.status}</span>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
                                    <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #f1f5f9', fontWeight: '700', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <Link2 size={18} /> Remorques
                                    </div>
                                    {[
                                        { plate: 'REM-001', type: 'Tautliner', status: 'Disponible', color: '#059669', bg: '#ecfdf5' },
                                        { plate: 'REM-002', type: 'Frigorifique', status: 'Indisponible', color: '#475569', bg: '#f1f5f9' },
                                    ].map((r, i) => (
                                        <div key={i} style={{ padding: '0.9rem 1.5rem', borderBottom: '1px solid #f8fafc', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: '0 0 0.2rem', fontSize: '0.9rem', fontWeight: '700', color: '#0f172a' }}>{r.plate}</p>
                                                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>{r.type}</p>
                                            </div>
                                            <span style={{ fontSize: '0.78rem', fontWeight: '600', padding: '0.2rem 0.6rem', borderRadius: '9999px', backgroundColor: r.bg, color: r.color }}>{r.status}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3 Resource Types Cards */}
            <section style={{ padding: '5rem 5%', backgroundColor: '#ffffff', borderTop: '1px solid #e2e8f0' }}>
                <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
                        <h2 style={{ fontSize: '2.5rem', color: '#0f172a', marginBottom: '1rem' }}>3 types de ressources gérés</h2>
                        <p style={{ fontSize: '1.15rem', color: '#475569', maxWidth: '600px', margin: '0 auto' }}>
                            Un module unique pour votre flotte humaine, votre flotte de traction et votre parc remorques.
                        </p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
                        {[
                            {
                                icon: <Users size={32} color="#4338ca" />,
                                bg: '#eef2ff',
                                title: 'Chauffeurs',
                                items: ['Fiche complète avec permis', 'Disponibilité ajustable', 'Accès application mobile', 'Documents attachés', 'Historique des missions']
                            },
                            {
                                icon: <Truck size={32} color="#059669" />,
                                bg: '#ecfdf5',
                                title: 'Véhicules',
                                items: ['Parc de camions', 'Statuts : Dispo / Indispo / Maintenance', 'Informations techniques', 'Assignation aux missions']
                            },
                            {
                                icon: <Link2 size={32} color="#7c3aed" />,
                                bg: '#f5f3ff',
                                title: 'Remorques',
                                items: ['Parc de remorques dédié', 'Statuts et disponibilité', 'Vérification avant assignation', 'Gestion indépendante']
                            }
                        ].map((res, i) => (
                            <div key={i} style={{ padding: '2rem', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                <div style={{ padding: '0.85rem', backgroundColor: res.bg, borderRadius: '12px', width: 'fit-content', marginBottom: '1.25rem' }}>
                                    {res.icon}
                                </div>
                                <h3 style={{ fontSize: '1.2rem', color: '#0f172a', marginBottom: '1rem', fontWeight: '700' }}>{res.title}</h3>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                                    {res.items.map((item, j) => (
                                        <div key={j} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <CheckCircle2 size={16} color="#4338ca" style={{ flexShrink: 0 }} />
                                            <span style={{ fontSize: '0.95rem', color: '#475569' }}>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Metrics Banner */}
            <section style={{ backgroundColor: '#0f172a', color: 'white', padding: '5rem 5%' }}>
                <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', textAlign: 'center' }}>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>3</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Types de ressources</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>Live</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Disponibilités actualisées</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 'bold', color: '#818cf8', marginBottom: '0.5rem' }}>100%</div>
                        <div style={{ fontSize: '1.1rem', color: '#94a3b8' }}>Ressources tracées</div>
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="saas-hero" style={{ padding: '6rem 5%', textAlign: 'center', backgroundColor: '#ffffff' }}>
                <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#0f172a' }}>Prenez le contrôle de vos ressources</h2>
                <p style={{ maxWidth: '600px', margin: '0 auto 2.5rem', fontSize: '1.15rem', color: '#475569', lineHeight: '1.6' }}>
                    Ne planifiez plus à l'aveugle. Accédez à l'état réel de chaque ressource et assignez vos missions avec confiance.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                    <Link to="/contact" className="saas-btn saas-btn-primary" style={{ padding: '1rem 2.5rem', fontSize: '1.15rem', borderRadius: '8px' }}>
                        Contacter notre équipe <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default GestionRessources;
